module.exports = "<form>\r\n  <spk-card title=\"Search Error Logs\">\r\n    <spk-search-grid #grid defaultSortProperty=\"Id DESC\" list=\"ErrorLogSearchRow\" [leftLinks]=\"leftLinks\"></spk-search-grid>\r\n  </spk-card>\r\n</form>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/logging/error-logs/error-logs.component.html
// module id = ./src/app/components/framework/logging/error-logs/error-logs.component.html
// module chunks = main